import _ from "lodash"
import React, { useEffect, useState } from "react"
import { animateScroll as scroll } from "react-scroll"
import { checkIfDuplicatesInArray } from "../../../../util"
import MatchfitQuestionElement from "../MatchfitQuestionElement"

function FormSection({
  currentSection,
  form,
  lastPage,
  onChangeHandler,
  onInputChangeHandler,
  onSubmit,
  groupName,
  questionSet,
  setCurrentSection,
  title,
}) {
  const [invalidInput, setInvalidInput] = useState(true)
  const [subform, setSubform] = useState([])
  const [inflight, setInflight] = useState(false)
  const [userInputDetected, setUserInputDetected] = useState(false)
  const [showWarning, setShowWarning] = useState(false)
  const {
    compulsory_question_slugs: compulsoryQuestionSlugs,
    input_question_slugs: inputQuestionSlugs,
    questions,
  } = questionSet

  const onNextStep = () => {
    if (userInputDetected && !invalidInput) {
      setCurrentSection(currentSection + 1)
    } else {
      setShowWarning(true)
    }
  }

  const onPreviousStep = () => {
    setCurrentSection(currentSection - 1)
  }

  // OnClick handler for the answers
  const onCheckHandler = e => {
    const { name, id } = e.target
    const formCopy = [...subform]
    formCopy[name] = { answer_id: id }
    setSubform(formCopy)
    onChangeHandler(e)

    // Scroll to next question
    const { innerWidth } = window
    scroll.scrollMore(innerWidth <= 770 ? 200 : 200, {
      duration: 500,
      smooth: "easeInOutQuad",
    })
  }

  useEffect(() => {
    if (currentSection === questionSet.page_index) {
      const greenHours = _.get(form, "weekly_green_spaces.number_field")
      const greenMinutes = _.get(form, "weekly_green_spaces_minutes.number_field")
      const sleepHours = _.get(form, "sleep_duration.number_field")
      const sleepMinutes = _.get(form, "sleep_duration_minutes.number_field")
      const funHours = _.get(form, "fun_duration.number_field")
      const funMinutes = _.get(form, "fun_duration_minutes.number_field")

      const isInvalidInput = greenHours > 167
        || sleepHours > 23
        || funHours > 23
        || greenMinutes > 59
        || sleepMinutes > 59
        || funMinutes > 59
      setInvalidInput(isInvalidInput)

      // If any input questions on this page are answered, then Warning is skipped
      if (title === "Switching Off") {
        setUserInputDetected(form.weekly_green_spaces && greenHours >= 0)
      } else if (checkIfDuplicatesInArray([...Object.keys(form), ...inputQuestionSlugs])) {
        setUserInputDetected(true)
      } else {
        setUserInputDetected(false)
      }
    } else {
      setShowWarning(false)
    }
  }, [currentSection, form, inputQuestionSlugs, questionSet.page_index, title])

  useEffect(() => {
    if (currentSection === questionSet.page_index) {
      scroll.scrollToTop()
    }
  }, [currentSection, questionSet.page_index])

  const onClickSubmit = e => {
    if (userInputDetected && !invalidInput) {
      setInflight(true)
      Promise.resolve(onSubmit(e))
        .catch(() => {})
        .finally(() => setInflight(false))
    } else {
      setShowWarning(true)
    }
  }

  const handleInputChange = e => {
    setUserInputDetected(true)
    onInputChangeHandler(e)
  }

  if (currentSection !== questionSet.page_index) return null
  return (
    <>
      {groupName && <h5>{groupName}</h5>}
      <h1>{title}</h1>
      <hr />
      {questions.map(question => (
        <MatchfitQuestionElement
          form={form}
          key={`question-${question.id}`}
          onChangeHandler={onCheckHandler}
          onInputChangeHandler={handleInputChange}
          integerOnly
          question={question}
          selectedAnswer={form[question.question_slug]}
          surveyType="matchfit" />
      ))}
      {inflight ? (
        <div className="bottom-cta d-flex justify-content-center">
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      ) : (
        <div>
          {showWarning && !userInputDetected && (
            <div className="bottom-cta mb-5 pb-3 d-flex justify-content-center bg-warning">Note: Please enter a value for time (hours).</div>
          )}
          {showWarning && invalidInput && (
            <div className="bottom-cta mb-5 pb-3 d-flex justify-content-center bg-warning">
              Note: Please enter a maximum of
              {" "}
              {title === "Switching Off" ? 167 : 23}
              {" "}
              hours or 59 minutes.
            </div>
          )}
          <div className="bottom-cta d-flex">
            {(currentSection !== 0) && (
              <button
                className="btn btn-light"
                type="button"
                onClick={onPreviousStep}>
                Previous
              </button>
            )}
            {questionSet.page_index === lastPage ? (
              <button
                className="btn btn-main ml-auto"
                disabled={_.difference(compulsoryQuestionSlugs, Object.keys(form)).length > 0 || inflight}
                type="button"
                onClick={onClickSubmit}>
                Done
              </button>
          ) : (
            <button
              className="btn btn-main ml-auto"
              type="button"
              disabled={_.difference(compulsoryQuestionSlugs, Object.keys(form)).length > 0}
              onClick={onNextStep}>
              Next
            </button>
          )}
          </div>
        </div>
      )}
    </>
  )
}

export default FormSection